import { IconAction } from './Action';
import { IconAnimation } from './Animation';
import { IconArrow } from './Arrow';
import { IconChevron } from './Chevron';
import { IconCircle } from './Circle';
import { IconMisc } from './Misc';
const IconList = {
    ...IconMisc,
    ...IconChevron,
    ...IconArrow,
    ...IconAction,
    ...IconCircle,
    ...IconAnimation,
};
export const Icon = IconList;
//# sourceMappingURL=index.js.map